import $ from 'jquery';
import { Cookie, updatePrices } from '../utilities';
import { geoCityLocate } from '../queries';

const getBrowserGeoLocation = () => {
    return new Promise(resolve => {
        if (!navigator.geolocation) {
            resolve(null);
            return;
        }
        navigator.geolocation.getCurrentPosition((position => {
            resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            });
        }), () => {
            resolve(null);
        });
    });
};

/**
 * устанавливает город в заголовок и номер склада
 */
const setCityName = (name) => {
    $('.header-city__control span').text(name);
    $('.header-city-hint__title span').text(name);
};

if (!Cookie.get('CITY_NAME') || !Cookie.get('CITY_FIAS_ID') || !Cookie.get('CITY_LAT') || !Cookie.get('CITY_LNG') || !Cookie.get('CITY_INDEX')) {
    (async function () {
        const response = await geoCityLocate();
        if (!response.isSuccess) {
            return;
        }
        // setCityName(response.city.name);
        // $('.header-city-hint').addClass('header-city-hint--visible');
    }());
}

$('.js-header-city-hint--apply').click(function () {
    $('.header-city-hint').removeClass('header-city-hint--visible');
});

$('.js-header-city-hint--select').click(function () {
    $('.header-city-hint').removeClass('header-city-hint--visible');
    $('.ui-modal[data-name="city"]').trigger('show');
});

$(document).on('click', '.js-header-city-set', async function () {
    $('.ui-modal').trigger('hide');

    console.log({ city: $(this).attr('data-name') });
    Cookie.set('CITY_NAME', $(this).attr('data-name'), false);
    Cookie.set('CITY_FIAS_ID', $(this).attr('data-fias-id'), false);
    Cookie.set('CITY_LAT', $(this).attr('data-lat'), false);
    Cookie.set('CITY_LNG', $(this).attr('data-lng'), false);
    Cookie.set('CITY_INDEX', $(this).attr('data-index'), false);

    if (location.pathname === '/order/') {
        location.reload();
    }
    if (location.pathname === '/register/') {
        location.reload();
    }
    setCityName($(this).attr('data-name'));
    //checkStoreId();
});
